// Curated timezone list — recon Open Q 16 picked a short list (~12 entries)
// over the full IANA database to keep the picker scannable. Matches the
// prototype's <select> with three placeholder rows; we expand to the major
// markets a single-user manager realistically operates from.
//
// Each entry maps an IANA identifier to a localisable label key. The
// section uses `Intl.DateTimeFormat` to render the live "UTC±HH:MM" prefix
// at component-mount time so DST changes show correctly without rebuilding
// the catalogue.

export interface TimezoneOption {
  /** IANA timezone (`Europe/Paris`, etc.). */
  id: string;
  /** Localisable key fragment under `common:timezones`, fallback display label. */
  label: string;
}

export const CURATED_TIMEZONES: readonly TimezoneOption[] = [
  { id: 'Europe/Paris', label: 'Europe/Paris — Paris' },
  { id: 'Europe/London', label: 'Europe/London — London' },
  { id: 'Europe/Berlin', label: 'Europe/Berlin — Berlin' },
  { id: 'Europe/Madrid', label: 'Europe/Madrid — Madrid' },
  { id: 'Europe/Lisbon', label: 'Europe/Lisbon — Lisbon' },
  { id: 'Europe/Zurich', label: 'Europe/Zurich — Zurich' },
  { id: 'America/New_York', label: 'America/New_York — New York' },
  { id: 'America/Chicago', label: 'America/Chicago — Chicago' },
  { id: 'America/Denver', label: 'America/Denver — Denver' },
  { id: 'America/Los_Angeles', label: 'America/Los_Angeles — Los Angeles' },
  { id: 'America/Sao_Paulo', label: 'America/Sao_Paulo — São Paulo' },
  { id: 'Asia/Singapore', label: 'Asia/Singapore — Singapore' },
  { id: 'Asia/Tokyo', label: 'Asia/Tokyo — Tokyo' },
  { id: 'Australia/Sydney', label: 'Australia/Sydney — Sydney' },
  { id: 'UTC', label: 'UTC — Coordinated Universal Time' },
];

/**
 * Try to detect the browser's IANA timezone. Falls back to `Europe/Paris`
 * (matching `users.timezone` default) when `Intl` is unavailable or the
 * detected value is not in our curated list.
 */
export function detectBrowserTimezone(): string {
  try {
    const guess = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (guess && CURATED_TIMEZONES.some((tz) => tz.id === guess)) return guess;
    return 'Europe/Paris';
  } catch {
    return 'Europe/Paris';
  }
}
